var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-group',{attrs:{"columns":""}},_vm._l((_vm.items),function(item,inx){return _c('ImageView',{key:inx,attrs:{"item":item,"page":_vm.page}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }